import React, { ReactFragment } from 'react';

export type Props = {
  children: (isMobile) => ReactFragment;
};

export function Responsive({ children: render }: Props) {
  return (
    <>
      <div className="is-hidden-touch is-hidden-tablet-only">{render(false)}</div>
      <div className="is-hidden-desktop">{render(true)}</div>
    </>
  );
}
